/**
 * Profile Use Cases Factory
 *
 * @module @personnel/composition/factories/createProfileUseCases
 */

import type { AxiosInstance } from 'axios';
import type { ProfileUseCases } from '@personnel/composition/types';

import { createProfileApiRepository } from '@personnel/infrastructure/repositories/ProfileApiRepository';
import { getProfilesUseCase } from '@personnel/application/use-cases/GetProfilesUseCase';

/**
 * Assembles all profile use cases with their injected dependencies.
 *
 * @param httpClient - Axios instance for the connect API
 * @returns Fully composed profile use cases
 */
export const createProfileUseCases = (httpClient: AxiosInstance): ProfileUseCases => {
  const apiPort = createProfileApiRepository({ httpClient });

  return {
    getProfiles: getProfilesUseCase({ apiPort }),
  };
};
